import { refreshSession } from './client';
import { enterOfflineSessionIfRemembered, settleLostSession } from './offlineSession';
import { queryClient } from './queryClient';

/**
 * Si la renovación tarda más que esto (señal muy débil), la app abre con lo guardado (la sesión sin
 * conexión, si alguien había entrado) y la renovación sigue en segundo plano: nunca se queda en la
 * pantalla de carga esperando una red que no llega.
 */
export const RESTORE_WAIT_MS = 8000;

let restoring: Promise<void> | null = null;

async function restore(): Promise<void> {
  const refreshing = refreshSession().catch(() => null);
  let timer: ReturnType<typeof setTimeout> | undefined;
  const timeout = new Promise<'timeout'>((resolve) => {
    timer = setTimeout(() => resolve('timeout'), RESTORE_WAIT_MS);
  });
  const result = await Promise.race([refreshing, timeout]);
  clearTimeout(timer);
  if (result === 'timeout') {
    enterOfflineSessionIfRemembered();
    return;
  }
  // Sin sesión: si quien usaba este dispositivo sigue sin red, entra sin conexión con sus datos guardados.
  if (!result) await settleLostSession(queryClient);
}

/**
 * Recupera la sesión al abrir la app con la cookie httpOnly de refresh (una sola vez por carga).
 * Sin cookie, con la cookie vencida o sin red, la app sigue como visitante (o con la sesión sin
 * conexión de la última persona): nunca falla.
 */
export function restoreSession(): Promise<void> {
  restoring ??= restore().catch(() => undefined);
  return restoring;
}

/** Loader de la ruta raíz: la primera pantalla ya sabe si hay sesión (sin parpadeo de visitante). */
export async function restoreSessionLoader(): Promise<null> {
  await restoreSession();
  return null;
}
